import { useParams } from "react-router-dom";
import { useState } from "react";
import { Copy } from "lucide-react";

function CampaignDetail() {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("overview");

  const webhookURL = `https://yourcrm.com/api/campaign/${id}/lead`;

  const htmlCode = `<form action="${webhookURL}" method="POST">
  <input type="text" name="name" placeholder="Full Name" required />
  <input type="email" name="email" placeholder="Email Address" required />
  <button type="submit">Submit</button>
</form>`;

  const jsCode = `<script>
function submitLead(data){
  fetch("${webhookURL}", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(data)
  });
}
</script>`;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="space-y-6">

      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">
          Campaign Integrations
        </h1>
        <p className="text-sm text-gray-500">
          Manage forms and webhook for Campaign #{id}
        </p>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b">
        {["overview", "webhook", "html form", "js form"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-3 capitalize transition ${
              activeTab === tab
                ? "border-b-2 border-blue-600 text-blue-600 font-medium"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm p-6">

        {/* OVERVIEW */}
        {activeTab === "overview" && (
          <div className="space-y-4">
            <p className="text-gray-700">
              Use the integration options below to capture leads from your website.
            </p>
            <div className="grid md:grid-cols-3 gap-4 mt-4">
              <div className="border p-4 rounded-lg">
                <h3 className="font-medium">Webhook</h3>
                <p className="text-sm text-gray-500 mt-2">
                  Send leads from external systems.
                </p>
              </div>

              <div className="border p-4 rounded-lg">
                <h3 className="font-medium">HTML Form</h3>
                <p className="text-sm text-gray-500 mt-2">
                  Embed form directly into your website.
                </p>
              </div>

              <div className="border p-4 rounded-lg">
                <h3 className="font-medium">JS Form</h3>
                <p className="text-sm text-gray-500 mt-2">
                  Submit leads using JavaScript.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* WEBHOOK */}
        {activeTab === "webhook" && (
          <div className="space-y-4">
            <label className="block text-sm font-medium">
              Webhook URL
            </label>

            <div className="flex">
              <input
                type="text"
                readOnly
                value={webhookURL}
                className="w-full p-3 border rounded-l-lg bg-gray-50 text-sm"
              />
              <button
                onClick={() => copyToClipboard(webhookURL)}
                className="px-4 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700"
              >
                <Copy size={18} />
              </button>
            </div>
          </div>
        )}

        {/* HTML FORM */}
        {activeTab === "html form" && (
          <div className="space-y-4">
            <textarea
              readOnly
              value={htmlCode}
              className="w-full h-48 p-4 border rounded-lg bg-gray-50 text-sm"
            />
            <button
              onClick={() => copyToClipboard(htmlCode)}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
              Copy HTML Code
            </button>
          </div>
        )}

        {/* JS FORM */}
        {activeTab === "js form" && (
          <div className="space-y-4">
            <textarea
              readOnly
              value={jsCode}
              className="w-full h-48 p-4 border rounded-lg bg-gray-50 text-sm"
            />
            <button
              onClick={() => copyToClipboard(jsCode)}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
              Copy JS Code
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default CampaignDetail;
